import ApiUtil from '../utils/ApiUtil';
import { getRequest, postRequest } from './api';

export const saveApi = (args, callback) => {
  const endpoint = '/v1/saves',
    token = args.token,
    headers = {};
  postRequest({endpoint, token}, headers, args.body, (err, res) => {
    ApiUtil.handleReponse(err, res, callback);
  });
};

export const getSavedApi = (args, callback) => {
  const endpoint = '/v1/saves',
    token = args.token,
    qs = `type=${args.type}`,
    headers = {'Cache-Control': 'no-cache, no-store, must-revalidate'};

  getRequest({endpoint, token, qs}, headers, (err, res) => {
    ApiUtil.handleReponse(err, res, callback);
  });
};
